import { Form, Input } from 'antd';
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { singleUserInputInputWithLabelAndSvgProps } from './types';
const InputWithLabelAndSvg: FC<singleUserInputInputWithLabelAndSvgProps> = (
	props
) => {
	// Inits
	const { singleUserInput, disabled, focus, setIsPasswordValidate } = props;

	const inputRef = useRef<HTMLInputElement>(null);

	const initialCall = useCallback(() => {
		if (focus && inputRef.current) {
			inputRef.current.focus();
		}
	}, [focus]);

	useEffect(() => {
		initialCall();
	}, [initialCall]);

	const [, setPasswordValidations] = useState<{
		minLength?: boolean;
		hasSpecialAndNumber?: boolean;
	}>({});

	const handlePasswordChange = (password: string) => {
		const isValidLength = password.length >= 8 && password.length <= 16;
		const hasSpecialAndNumber =
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]*$/.test(
				password
			);

		setIsPasswordValidate(password.length ? true : false); //isValidLength && hasSpecialAndNumber
		setPasswordValidations({
			minLength: isValidLength,
			hasSpecialAndNumber: hasSpecialAndNumber,
		});
	};

	// JSX
	return (
		<div className={styles['input-icon']}>
			{singleUserInput.id !== 'phone' ? (
				<>
					<div className={styles['input-icon__title']}>
						{singleUserInput.svg && (
							<div className={styles['input-icon__title--svg']}>
								{singleUserInput.svg}
							</div>
						)}
						<label className={styles['input-icon__title--label']}>
							{singleUserInput.title}
							{singleUserInput?.required && (
								<span className="required-color">*</span>
							)}
						</label>
					</div>

					<div className={styles['input-icon__form']}>
						<Form.Item
							name={singleUserInput.name}
							rules={singleUserInput.rules}
						>
							{(singleUserInput.type === 'text') && (
								<Input
									placeholder={singleUserInput.placeHolder}
									size="large"
									className={
										styles['input-icon__form--input']
									}
									type={singleUserInput.type}
									disabled={disabled ? disabled : false}
									ref={inputRef as any}
								/>
							)}

							{
								singleUserInput.type === 'number' && (
									<Input
										placeholder={singleUserInput.placeHolder}
										size="large"
										className={
											styles['input-icon__form--input']
										}
										type={singleUserInput.type}
										min={0}
										step={singleUserInput.step ? singleUserInput.step : 0}
										disabled={disabled ? disabled : false}
										ref={inputRef as any}
										onKeyDown={(e) => {
											if (['-', 'e', '+'].includes(e.key)) {
												e.preventDefault(); // block typing "-", "e", or "+"
											}
										}}
										onWheel={(e) => e.currentTarget.blur()}
									/>
								)
							}

							{singleUserInput.type === 'password' && (
								<div>
									<Input.Password
										placeholder={
											singleUserInput.placeHolder
										}
										size="large"
										className={
											styles['input-icon__form--input']
										}
										onChange={(e) =>
											handlePasswordChange(e.target.value)
										}
									/>
								</div>
							)}
						</Form.Item>
						{/* {singleUserInput.id === 'password' && (
							<div>
								<PasswordValidation
									minLength={passwordValidations.minLength}
									hasSpecialAndNumber={
										passwordValidations.hasSpecialAndNumber
									}
								/>
							</div>
						)} */}
					</div>
				</>
			) : (
				``
			)}

		</div>
	);
};

export default InputWithLabelAndSvg;
